<template>
  <div class="invite-box text-center">
    <p class="title">{{ $t('MyInvitationCode') }}</p>
    <div class="invite-info">
      <p class="invite-code">{{ $t('invitationCode') }}：<span>{{ invitationCode }}</span></p>
      <invite-url :invitation-code="invitationCode" class="invite-url-component"></invite-url>
      <p class="describe">{{ $t('explain') }}</p>
    </div>
  </div>
</template>

<script>
  import InviteUrl from '../../components/inviteUrl/Index.vue'
  import locales from './lang'

  export default {
    name: 'invite-view',
    components: {InviteUrl},
    props: {
      invitationCode: {}
    },
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  * {
    padding: 0;
    margin: 0;
  }

  .invite-box {
    background: #FFFFFF;
    border: 1px solid #e0d7e3;
    border-radius: 8px;
    height: 2.85rem;
    margin-bottom: 0.24rem;
  }

  p.title {
    text-align: left;
    font-size: .16rem;
    line-height: .48rem;
    height: .48rem;
    padding: 0 .16rem;
    border-bottom: 1px solid #e0d7e3;
    color: #111;
    margin-bottom: .43rem;
  }

  .invite-info {
    padding: 0 .16rem;
    .invite-code {
      font-size: 12px;
      color: #666;
      letter-spacing: 0;
      line-height: .18rem;
      margin-bottom: .16rem;
      span {
        font-size: 18px;
        line-height: .26rem;
        color: #F15A66;
        font-weight: 500;
        letter-spacing: 0;
      }
    }
    .invite-url-component {
      margin-bottom: .35rem;
    }
    .describe {
      font-size: 14px;
      line-height: 20px;
      color: #666;
      letter-spacing: 0;
    }
  }

  @media (max-width: 767px) {
    p.title {
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      margin-bottom: .24rem;
    }
    .invite-info {
      .invite-code {
        margin-bottom: .24rem;
      }
      .invite-url-component {
        margin-bottom: .16rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// InviteFriend.vue?480e91ee